import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const mobileNavItemHeight = '4.375rem';
export const Container = styled.div `
  display: flex;
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${theme.semantic.surface.primary};
  box-shadow:
    0 0 ${pxToRem(0.1)} rgb(0 0 0 / 2%),
    0 0 ${pxToRem(0.3)} rgb(0 0 0 / 2.8%),
    0 0 ${pxToRem(0.6)} rgb(0 0 0 / 3.5%),
    0 0 ${pxToRem(1.1)} rgb(0 0 0 / 4.2%),
    0 0 ${pxToRem(2.1)} rgb(0 0 0 / 5%),
    0 0 ${pxToRem(5)} rgb(0 0 0 / 7%);
`;
export const Navigation = styled.nav `
  display: flex;
  width: 100%;
  align-items: stretch;
  justify-content: stretch;
`;
export const NavItemText = styled.span `
  margin-top: ${theme.spacing.md};
  font-size: ${theme.fontSize.tiny};
  line-height: ${theme.lineHeight.none};
`;
export const NavItemContainer = styled.button `
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: ${mobileNavItemHeight};
  border: none;
  background-color: transparent;
  text-decoration: none;

  svg {
    color: ${({ $active }) => ($active ? theme.swatches.warm[500] : theme.semantic.foreground.disabled)};
  }

  font-weight: ${({ $active }) => ($active ? theme.fontWeight.semibold : theme.fontWeight.regular)};

  ${NavItemText} {
    color: ${({ $active }) => ($active ? theme.swatches.gray[700] : theme.semantic.foreground.disabled)};
  }
`;
